var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ATTACHED_MARKER = "horaEmailValidator";
const HINT_CLASS = "hora-email-hint";
const HINT_TONE = {
    suggestion: "hora-email-hint--suggestion",
    error: "hora-email-hint--error",
};
const REASON_MESSAGES = {
    invalid_format: "Please enter a valid email address.",
    disposable_address: "Disposable email addresses are not accepted.",
    domain_cannot_receive_mail: "This domain cannot receive email.",
};
export function attachEmailValidator(input, opts) {
    if (input.dataset[ATTACHED_MARKER] === "1") {
        return;
    }
    input.dataset[ATTACHED_MARKER] = "1";
    let abortController = null;
    const clearHint = () => {
        const existing = findHint(input);
        if (existing)
            existing.remove();
    };
    const renderSuggestion = (suggestion) => {
        clearHint();
        const hint = document.createElement("div");
        hint.className = `${HINT_CLASS} ${HINT_TONE.suggestion}`;
        hint.setAttribute("role", "status");
        const prefix = document.createTextNode("Did you mean ");
        const link = document.createElement("a");
        link.href = "#";
        link.className = "hora-email-suggestion";
        link.textContent = suggestion;
        const suffix = document.createTextNode("?");
        link.addEventListener("click", (event) => {
            event.preventDefault();
            input.value = suggestion;
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("change", { bubbles: true }));
            clearHint();
            void runValidation();
        });
        hint.appendChild(prefix);
        hint.appendChild(link);
        hint.appendChild(suffix);
        insertAfter(input, hint);
    };
    const renderError = (reason) => {
        clearHint();
        if (reason === "possible_typo" || reason === "empty")
            return;
        const message = REASON_MESSAGES[reason];
        if (!message)
            return;
        const hint = document.createElement("div");
        hint.className = `${HINT_CLASS} ${HINT_TONE.error}`;
        hint.setAttribute("role", "alert");
        hint.textContent = message;
        insertAfter(input, hint);
    };
    const showSpinner = () => {
        clearHint();
        const hint = document.createElement("div");
        hint.className = `${HINT_CLASS} hora-email-hint--loading`;
        hint.innerHTML = '<span class="hora-spinner" role="status" aria-label="Validating"></span>';
        insertAfter(input, hint);
    };
    const runValidation = () => __awaiter(this, void 0, void 0, function* () {
        const email = input.value.trim();
        if (email === "") {
            clearHint();
            return;
        }
        abortController === null || abortController === void 0 ? void 0 : abortController.abort();
        abortController = new AbortController();
        showSpinner();
        try {
            const response = yield fetch(`${opts.restUrl.replace(/\/$/, "")}/validate-email`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": opts.nonce,
                },
                body: JSON.stringify({ email }),
                signal: abortController.signal,
                credentials: "same-origin",
            });
            if (!response.ok) {
                clearHint();
                return;
            }
            const result = yield response.json();
            if (result.valid) {
                clearHint();
                return;
            }
            if (result.suggestion) {
                renderSuggestion(result.suggestion);
                return;
            }
            if (result.reason) {
                renderError(result.reason);
            }
            else {
                clearHint();
            }
        }
        catch (err) {
            if ((err === null || err === void 0 ? void 0 : err.name) === "AbortError")
                return;
            clearHint();
            console.warn("Email validation request failed", err);
        }
    });
    input.addEventListener("blur", runValidation);
}
function findHint(input) {
    const next = input.nextElementSibling;
    if (next instanceof HTMLElement && next.classList.contains(HINT_CLASS)) {
        return next;
    }
    return null;
}
function insertAfter(input, node) {
    var _a;
    (_a = input.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(node, input.nextSibling);
}
export function attachEmailValidatorToForm(root, opts) {
    root
        .querySelectorAll('input[type="email"]')
        .forEach((input) => attachEmailValidator(input, opts));
}
